<template>
  <div class="yh-page">
    <el-card v-loading="saving || listLoading" :element-loading-text="loadingText">
      <div class="p-1 font-weight-bold border-bottom yh-section-title">基本信息</div>
      <el-row>
        <el-col :span="14">
          <el-form ref="form1" :rules="rules1" :model="fd1" label-position="left" label-width="80px"
                   class="mx-5 my-4 pt-2">
            <!-- 名称 -->
            <el-form-item label="名称" prop="name">
              <el-input v-model="fd1.name" placeholder="请输入保险公司名称"></el-input>
            </el-form-item>
            <!-- 简称 -->
            <el-form-item label="简称" prop="short_name">
              <el-input v-model="fd1.short_name" placeholder="请输入保险公司简称"></el-input>
            </el-form-item>
            <el-form-item label="归属组" prop="father_company">
              <el-input v-model="fd1.father_company" placeholder="请输入归属组名称"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="邮件信息" name="email_info">
          <div class="p-1 font-weight-bold border-bottom yh-section-title">指定发送邮箱</div>
          <el-row>
            <el-col :span="14">
              <el-form ref="form1" :rules="rules1" :model="fd1" label-position="left" label-width="80px"
                      class="mx-5 my-4 pt-2">
                <!-- 名称 -->
                <el-form-item label="邮箱账号" prop="">
                  <el-input v-model="fd1.email" placeholder="如输入指定发送邮箱，则不会使用当前操作员邮箱发送"></el-input>
                </el-form-item>
                <!-- 简称 -->
                <el-form-item label="邮箱密码" prop="">
                  <el-input name="password" type="password" v-model="fd1.email_password" autoComplete="on"
                            placeholder="请输入邮箱密码" />
                </el-form-item>
                <el-form-item prop="" label="称呼">
                  <el-input type="textarea" v-model="fd1.solutation" :autosize="{minRows: 4, maxRows: 8}"
                            placeholder="请输入称呼"></el-input>
                </el-form-item>
                <el-form-item prop="email_signature" label="邮件签名">
                  <el-input type="textarea" v-model="fd1.email_signature" :autosize="{minRows: 4, maxRows: 8}"
                            placeholder="请输入邮件签名"></el-input>
                </el-form-item>

              </el-form>
            </el-col>
          </el-row>

          <div class="p-1 font-weight-bold border-bottom yh-section-title mt-4">默认邮件联系信息</div>
          <el-row>
            <el-col :span="14">
              <el-form :rules="rules2" ref="form2" :model="fd2" label-position="left" label-width="80px"
                      class="font-weight-bold mx-5 my-4 pt-2">
                <!-- 称呼 -->
                <el-form-item label="称呼" prop="solutation">
                  <el-input type="textarea" v-model="fd2.solutation" :autosize="{minRows: 4, maxRows: 8}"
                            placeholder="请输入称呼"></el-input>
                </el-form-item>
                <!-- 收件人 -->
                <el-form-item label="收件人" prop="recipient">
                  <el-input type="textarea" v-model="fd2.recipient" :autosize="{minRows: 4, maxRows: 8}"
                            placeholder="请输入收件人，一个一行"></el-input>
                </el-form-item>
                <!-- 抄送人 -->
                <el-form-item label="抄送人" prop="copy">
                  <el-input type="textarea" v-model="fd2.copy" :autosize="{minRows: 4, maxRows: 8}"
                            placeholder="请输入抄送人，一个一行"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div v-if="pageStatus === 'action.edit'">
            <el-row class="p-1 border-bottom mt-4" type="flex" justify="space-between" align="middle">
              <div class="font-weight-bold yh-section-title">额外邮件联系信息</div>
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleContactCreate">新增</el-button>
            </el-row>
            <!-- 业务table -->
            <el-table ref="contact" :key="0" :data="contactList" :show-header="true" v-loading="listLoading"
                      :element-loading-text="loadingText" fit highlight-current-row class="pt-2">
              <!-- 邮件类型 -->
              <el-table-column align="left" label="邮件类型" width="80px">
                <template slot-scope="scope">
                  <span class="badge"
                        :class="{'badge-success': scope.row.type === 'inquery', 'badge-info': scope.row.type === 'issue'}">{{ scope.row.type_name }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="称呼" width="160px">
                <template slot-scope="scope">
                  <span>{{ scope.row.solutation }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="收件人">
                <template slot-scope="scope">
                  <span>{{ scope.row.recipient }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="抄送人" min-width="180px">
                <template slot-scope="scope">
                  <span>{{scope.row.copy }}</span>
                </template>
              </el-table-column>
              <!-- 按钮组 -->
              <el-table-column align="left" label="操作" width="100px">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
                    <el-button v-if="$perm(['company.view_insurance_company'])"
                              type="text" class="pr-1" @click="handleContactUpdate(scope.row.id)">
                      <svg-icon icon-class="edit"></svg-icon>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                    <el-button v-if="$perm(['company.delete_insurance_company'])"
                              type="text" @click="handleContactDelete(scope.row)"><i class="el-icon-delete"></i>
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="条款文件" name="clause_file" v-if="pageStatus === 'action.edit'">
          <el-button type="success" size="small" @click="handleUpload">上传条款</el-button>
          <el-table :key="0" stripe v-loading="listLoading"
                    :element-loading-text="loadingText" fit highlight-current-row
                    :data="fileList"
                    class="w-100 mt-2">
            <!-- 文件名称 -->
            <el-table-column align="left" label="文件名" width="250 px">
              <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <!-- 文件原名 -->
            <el-table-column align="left" label="文件原名">
              <template slot-scope="scope">
                <span>{{scope.row.original_name}}</span>
              </template>
            </el-table-column>
            <!-- 注册编号 -->
            <el-table-column align="left" label="注册编号">
              <template slot-scope="scope">
                <span>{{scope.row.clause_num}}</span>
                <el-input v-show="scope.row.id === edit_id" v-model="temp_clause_num"></el-input>
                <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
                  <el-button v-show="scope.row.id !== edit_id" size="mini" type="text"
                              @click="handleEdit(scope.row)"><i class="el-icon-edit"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="确定" placement="top-start">
                  <el-button v-show="scope.row.id === edit_id" size="mini" type="text"
                              @click="handleSaveEdit(scope.row)"><i class="el-icon-check"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="取消" placement="top-start">
                  <el-button v-show="scope.row.id === edit_id" size="mini" type="text"
                              @click="handleCancelEdit(scope.row)"><i class="el-icon-close"></i></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 文件大小 -->
            <el-table-column align="left" label="文件大小" width="100 px">
              <template slot-scope="scope">
                <span>{{scope.row.size | formatSize }}</span>
              </template>
            </el-table-column>
            <!-- 按钮组 -->
            <el-table-column align="left" label="操作" min-width="16%"
                             class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                  <el-button type="text" @click="handleFileDelete(scope.row)">
                    <i class="el-icon-delete"/>
                  </el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="下载" placement="top-start">
                  <el-button type="text" @click="handleDownload(scope.row)">
                    <i class="el-icon-download"/>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="候补文件配置" name="company_file" v-if="pageStatus === 'action.edit'">
          <div class="p-1 font-weight-bold border-bottom yh-section-title">
            勾选出单申请所需文件的类型，并选择是否可支持后补
          </div>
          <el-table :key="0" stripe v-loading="listLoading"
                    :element-loading-text="loadingText" fit highlight-current-row
                    :data="need_file_list"
                    ref="needFileTable"
                    @selection-change="handleSelectionChange"
                    class="w-100 mt-2">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <!-- 文件名称 -->
            <el-table-column align="left" label="文件名" width="250 px">
              <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="是否支持后补">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.can_supplement" />
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-row class="my-4" :class="pageStatus === 'action.create' ? 'border-top pt-4' : ''">
        <div style="margin-left: calc(3rem + 80px);">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button v-if="pageStatus === 'action.edit'" size="small" type="primary" @click="updateData">保存</el-button>
          <template v-if="pageStatus === 'action.create'">
            <el-button size="small" type="primary" @click="createData(1)">保存</el-button>
            <el-button size="small" type="primary" @click="createData(2)">保存并新增</el-button>
          </template>
        </div>
      </el-row>
    </el-card>
    <upload-dialog ref="uploaddlg" :company-data="fd1" @uploaded="handleUpdate(companyid)"></upload-dialog>
    <contact-dialog ref="contactdlg" :company-id="companyid" :contact-type-list="contactTypeList"
                    @updateList="handleUpdate(companyid)"></contact-dialog>
  </div>
</template>

<script>
  import {fetchDictList} from '@/api/common'
  import {downloadFile, removeFile, updateClauseNum} from '@/api/upload'
  import {
    createInsuranceCompany,
    fetchInsuranceCompany,
    updateInsuranceCompany,
    fetchContactListByCompanyId,
    createContact,
    updateContact,
    deleteContact,
    fetchClauseFileList,
    deleteClauseFile,
    fetchNeedFileOptionsList,
    fetchInsuranceCompanyNeedFileList,
  } from '@/api/insurance_company'
  import {formatSize} from "@/utils/misc";
  import ContactDialog from './contact-dialog'
  import UploadDialog from './upload-dialog'


  export default {
    name: "detail",
    data() {
      return {
        need_file_list:[],
        need_file_selection: [],
        companyFileList:[],
        edit_id: '',
        temp_clause_num: '',
        activeName: 'email_info',
        pageStatus: '',
        companyid: 0,
        fd1: {},
        fd2: {},
        contactList: [],
        contactTypeList: [],
        saving: false,
        listLoading: false,
        selectFileTypeVisible:false,
        loadingText: '正在加载数据，请稍等...',
        rules1: {
          name: [{required: true, message: '请输入保险公司名称', trigger: 'blur'}],
          short_name: [{required: true, message: '请输入保险公司简称', trigger: 'blur'}]
        },
        rules2: {
          recipient: [{required: true, message: '请输入收件人邮箱', trigger: 'blur'}]
        },
        email: '',
        email_password: '',
        email_signature: '',
        solutation: '',
        dialogTableVisible: false,
        fileList: []
      }
    },
    filters: {
      formatSize
    },
    components: {
      ContactDialog,
      UploadDialog
    },
    computed: {
    },
    methods: {
      resetFD() {
        this.fd1 = {}
        this.fd2 = {}
      },
      handleCreate() {
        this.pageStatus = 'action.create'
      },
      handleUpdate() {
        this.pageStatus = 'action.edit'
        let p = []
        p.push(fetchInsuranceCompany(this.companyid))
        p.push(fetchContactListByCompanyId(this.companyid))
        p.push(fetchDictList({type: 'insurance_company_contact.type'}))
        p.push(fetchNeedFileOptionsList())
        p.push(fetchInsuranceCompanyNeedFileList(this.companyid))

        this.listLoading = true
        Promise.all(p)
          .then(res => {
            this.fd1 = Object.assign({}, res[0])
            this.contactList = Object.assign([], res[1])
            this.contactList = res[1].filter(contact => {
              return (contact.type !== 'default')
            })
            this.fd2 = res[1].find(contact => {
              return (contact.type === 'default')
            })

            this.contactTypeList = res[2].filter(type => {
              return !res[1].some(item => {
                return (type.code == item.type)
              })
            })
            this.need_file_list = res[3]
            this.companyFileList = res[4]
            this.need_file_list.forEach(item => {
              this.$set(item, 'is_check', false)
              this.$set(item, 'can_supplement', false)
              this.companyFileList.forEach(item2 => {
                if (item.name === item2.need_file.name) {
                  this.$set(item, 'is_check', true)
                  if (item2.can_supplement === true) {
                    this.$set(item, 'can_supplement', true)
                  }
                }
              })
            })

            
            this.loadFileList(this.companyid);

            this.listLoading = false
            this.$nextTick(() => {
              this.$refs['form1'].clearValidate()
              this.$refs['form2'].clearValidate()
              if (this.$refs.needFileTable) {
                this.$refs.needFileTable.clearSelection()
                this.need_file_list.forEach(file => {
                  if(file.is_check) {
                    this.$refs.needFileTable.toggleRowSelection(file, true)
                  }
                })
              }
            })
          })
          .catch(error => {
            this.listLoading = false
            this.$error_message(error)
          })
      },
      handleSelectionChange(val) {
        this.need_file_selection = val
      },
      createData(type) {
        let valid1 = false, valid2 = false
        this.$refs['form1'].validate(valid => valid1 = valid)
        this.$refs['form2'].validate(valid => valid2 = valid)

        if (valid1 && valid2) {
          this.saving = true
          this.loadingText = '正在保存保险公司数据，请稍等...'
          createInsuranceCompany(this.fd1)
            .then(res => {
              this.companyid = res.id
              this.loadingText = '正在保存默认邮件联系数据，请稍等...'
              this.fd2.insurance_company = this.companyid
              this.fd2.type = 'default'
              return createContact(this.fd2)
            })
            .then(() => {
              this.saving = false
              this.$message.success('保存保险公司信息成功')
              this.$nextTick(() => {
                this.$refs.form1.clearValidate()
                this.$refs.form2.clearValidate()
                this.$refs.form1.resetFields()
                this.$refs.form2.resetFields()
                this.resetFD()
                if (type == 1) {
                  this.$router.push({name: 'listInsuranceCompany'})
                }
              })
            })
            .catch(error => {
              this.saving = false
              this.$error_message(error)
            })
        }
      },
      updateData() {
        let valid1 = false, valid2 = false
        this.$refs['form1'].validate(valid => valid1 = valid)
        this.$refs['form2'].validate(valid => valid2 = valid)

        if (valid1 && valid2) {
          this.saving = true
          this.loadingText = '正在更新保险公司数据，请稍等...'
          this.$set(this.fd1, 'need_file_list', this.need_file_selection)
          const tempData = Object.assign({}, this.fd1)
          updateInsuranceCompany(tempData.id, tempData)
            .then(res => {
              this.companyid = res.id
              this.loadingText = '正在更新默认邮件联系数据，请稍等...'
              this.fd2.insurance_company = this.companyid
              this.fd2.type = 'default'
              return updateContact(this.fd2.id, this.fd2)
            })
            .then(() => {
              this.saving = false
              this.$message.success('更新保险公司信息成功')
              this.$nextTick(() => {
                this.$refs.form1.clearValidate()
                this.$refs.form2.clearValidate()
                this.$refs.form1.resetFields()
                this.$refs.form2.resetFields()
                this.resetFD()
                this.handleUpdate(this.companyid)
                // this.$router.push({name: 'listInsuranceCompany'})
              })
            })
            .catch(error => {
              this.$error_message(error)
            })
        }
      },
      cancelData() {
        this.$refs.form1.clearValidate()
        this.$refs.form1.resetFields()
        this.$refs.form2.clearValidate()
        this.$refs.form2.resetFields()
        this.resetFD()
        this.$router.push({name: 'listInsuranceCompany'})
      },
      handleContactCreate() {
        this.$refs.contactdlg.handleCreate()
      },
      handleContactUpdate(id) {
        this.$refs.contactdlg.handleUpdate(id)
      },
      handleContactDelete(contact) {
        var msg = '是否删除' + contact.type_name + '邮件联系信息 ？'
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          deleteContact(contact.id)
            .then(() => {
              this.$message.success('删除邮件联系信息成功')
              this.handleUpdate(this.companyid)
            })
            .catch(error => {
              this.$error_message(error)
            })
        })
      },
      handleUpload() {
        this.$refs.uploaddlg.openDialog()
      },
      loadFileList(companyid) {
        fetchClauseFileList(companyid)
          .then(res => {
            this.fileList = res;
          })
          .catch(error => {
            this.$error_message(error);
          });
      },
      handleFileDelete(file) {
        var msg = "是否删除" + file.original_name + ' 文件 ？'
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          var deldata = {
            'companyid': this.companyid,
            'fileid': file.id
          }
          removeFile(file.id)
          .then(() => {
            deleteClauseFile(this.companyid, deldata)
              .then(() => {
                this.$message.success("保险条款文件删除成功")
                this.handleUpdate(this.companyid)
              })
              .catch(error => {
                this.$error_message(error)
              })
          })
          .catch(error => {
                this.$error_message(error)
          })
        })
      },
      handleDownload(file) {
        downloadFile(file.id)
          .then(res => {
            let link = document.createElement("a");
            link.style.display = "none";

            let blob = new Blob([res]);
            link.href = URL.createObjectURL(blob);

            link.download = file.name;
            document.body.appendChild(link);

            link.click();
            URL.revokeObjectURL(blob);
            document.body.removeChild(link);
          })
          .catch(error => {
            this.$error_message(error);
          });
      },
      handleEdit(row) {
        this.temp_clause_num = row.clause_num
        this.edit_id = row.id
      },
      handleCancelEdit(row) {
        this.temp_clause_num = ''
        this.edit_id = ''
      },
      handleSaveEdit(row) {
        let data = {'clause_num': this.temp_clause_num}
        updateClauseNum(row.id, data).then(res => {
          this.$message.success("保险条款文件更新成功")
          this.handleCancelEdit()
          this.handleUpdate(this.companyid)
        }).catch(error => {
          this.$error_message(error)
        })
      }
    },
    beforeRouteLeave (to, from, next) {
        if (to.name != 'listInsuranceCompany') {
          window.localStorage.removeItem('query')
        }
        next()
        },
    mounted() {
      if (this.$route.name === 'createInsuranceCompany') {
        if (this.$perm(['company.add_insurance_company'])) {
          this.handleCreate()
        } else {
          this.$router.push('/401')
        }
      }

      if (this.$route.name === 'updateInsuranceCompany') {
        let id = this.$route.query.id
        if (!id) {
          this.$route.push('/404')
        } else if (this.$perm(['company.view_insurance_company'])) {
          this.companyid = parseInt(id)
          this.handleUpdate()
        }
      }
    }
  }
</script>
